import React, { useEffect, useState } from 'react';
import Table from '../../../../components/Table/RsponsiveTable';
import TeamPerformanceTableColumnData from './TeamPerformanceTableColumnData';
import {
  getLoanProduct,
  getSourceList
} from '../../../../common/constants/api';
import './TeamPerformance.scss';
import {
  getFiltersInfo,
  setFiltersInfo
} from '../../../../common/utils/FiltersInfo';

const TeamPerformanceTable = ({
  tableData,
  tableInfo,
  tableLoading,
  setPageSize,
  setPage,
  rmId,
  setRmId,
  setFilteredProduct,
  filteredProduct,
  setSortColumnName,
  setSortDirName,
  firstLoading,
  changeMonth,
  source,
  setSource,
  pageSize
}) => {
  const [statusFiltersList, setSatusFiltersList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [filterStatus, setFilterStatus] = useState(
    getFiltersInfo()?.productId ? { Product: {} } : ''
  );
  const [sourceList, setSourceList] = useState([]);
  const [doRender, setRender] = useState(false);

  const customHandlePageChange = page => {
    setPage(page - 1);
  };
  const customHandleSort = async (column, sortDirection) => {
    setSortColumnName(column?.selector || '');
    setSortDirName(sortDirection);
  };
  const customHandleSearch = () => {};

  const customHandlePerRowsChange = (perPage, page) => {
    setPageSize(perPage);
    setPage(0);
  };
  useEffect(() => {
    getLoanProduct()
      .then(res => {
        if (res.error) throw new Error(res);
        let productList = [];
        if (res instanceof Array) {
          res.map(each => {
            productList.push({
              title: each.displayName,
              id: each.id,
              checked: getFiltersInfo().productId == each.id
            });
          });

          setFilterList([
            {
              name: 'Product',
              type: 'check',
              dropdown: productList
            }
          ]);
        }
      })
      .catch(error => {});
  }, []);

  useEffect(() => {
    let dropDownList = [];
    filterList[0]?.dropdown?.map(each => {
      dropDownList.push({
        title: each.title,
        id: each.id,
        checked: each.id == filteredProduct ? true : false
      });
    });
    setFilterList([
      {
        name: 'Product',
        type: 'check',
        dropdown: dropDownList
      }
    ]);
  }, [filteredProduct]);

  useEffect(() => {
    if (firstLoading) return;
    let products = '';
    if (!filterStatus?.Source) setSource('');
    setSource(
      filterStatus?.Source &&
        Object?.keys(filterStatus?.Source)?.filter(
          each => filterStatus?.Source?.[each]
        )
    );

    if (typeof filterStatus == 'undefined') return;
    if (!filterStatus?.Product) return setFilteredProduct('');

    Object.keys(filterStatus?.Product).map(each => {
      filterList[0]?.dropdown.map(every => {
        if (filterStatus?.Product[each] && every?.title == each) {
          products += `${every.id}`;
        }
      });
    });

    setFilteredProduct(products);
  }, [filterStatus]);

  const getSourceData = () =>
    getSourceList()
      .then(res => {
        if (res?.error) throw new Error(res);
        setSourceList(
          res?.map(each => {
            return {
              htmlTitle: (
                <span className="text-blue-1101">{each?.displayName}</span>
              ),
              title: `${each?.id}`,
              checked:
                getFiltersInfo()?.sourceFilter?.toString() == `${each?.id}`
                  ? true
                  : false
            };
          })
        );
      })
      .catch(error => {});

  useEffect(() => {
    getSourceData();
  }, []);

  useEffect(() => {
    setFiltersInfo({
      ...(getFiltersInfo() || {}),
      sourceFilter: source?.toString()
    });
    setSourceList(
      sourceList?.map(each => {
        return {
          htmlTitle: each?.htmlTitle,
          title: each?.title,
          checked: getFiltersInfo()?.sourceFilter?.toString() == each?.title
        };
      })
    );
    setRender(!doRender);
  }, [source]);

  return (
    <div className="w-full teamPerformanceTable">
      <Table
        data={tableData}
        columns={TeamPerformanceTableColumnData(
          rmId,
          filteredProduct,
          changeMonth
        )}
        serverPagination={true}
        CustomhandlePerRowsChange={customHandlePerRowsChange}
        CustomhandlePageChange={customHandlePageChange}
        CustomhandleSort={customHandleSort}
        CustomhandleSearch={customHandleSearch}
        serverSort={true}
        TableInfo={tableInfo}
        tableLoading={tableLoading}
        filterComponent={true}
        GetLeadStatus={[
          ...filterList,
          sourceList?.length > 0 && {
            name: 'Source',
            type: 'check',
            dropdown: sourceList
          }
        ]}
        filterCaption="Filter"
        rows={pageSize}
        tableListbelongs="Leads"
        page={tableInfo?.number?.toString() || 0}
        showNumberOfListStyle={{ display: 'none' }}
        setRmId={setRmId}
        rmId={rmId}
        rm={true}
        searchStyle={{ display: 'none' }}
        setFilterStatus={setFilterStatus}
        filterBlock="Product"
        filterMultiSelect={false}
        render={doRender}
      />
    </div>
  );
};

export default TeamPerformanceTable;
